import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getJiraApplicationKey } from '../../../services/get-jira-application-key';
import { getJiraProjectTypeKey } from '../../../services/get-jira-project-type-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './entrypoint';

export function StandardTrialLimitBreakersModal() {
	const { product, cloudId } = useEditionAwareness();

	const jiraApplicationKey = getJiraApplicationKey(product);
	const projectType = getJiraProjectTypeKey(product);

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE', // Only supports Jira Software
			projectType: projectType ?? 'SOFTWARE', // Only supports Jira Software
			shouldIncludeIfProductIsConfluence: product === 'confluence',
			shouldIncludeIfProductIsJiraSoftware: product === 'jira',
		}),
		[cloudId, product, projectType, jiraApplicationKey],
	);

	const modalProps = useMemo(() => ({ width: 'x-large' }), []);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
